import { antigenApi } from "api/immunization";
import MasterListScreen from "./common/MasterListScreen";
import AntigenModal from "./AntigenModal";

const AntigenList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={antigenApi}
    label="Antigen"
    entityLabel="antigen"
    addLabel="Add Antigen"
    tag="immunization-antigen"
    headers={[
      "Name",
      "Code",
      "Disease",
      "Group",
      "Booster (days)",
      "Status",
      "Action",
    ]}
    keys={[
      "name",
      "code",
      "diseaseName",
      "diseaseGroup",
      "boosterLabel",
      "statusChip",
      "action",
    ]}
    displayName={(item) => item.antigenName}
    mapRow={(item) => ({
      boosterLabel:
        item.confersLifetimeImmunity ? "Lifetime immunity" : (
          item.defaultBoosterIntervalDays || "—"
        ),
    })}
    Modal={AntigenModal}
    searchText={searchText}
  />
);

export default AntigenList;
